export const awsImagePaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/images`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/images`,
  detail: (connectionId, region, imageId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/images/${encodeURIComponent(region)}/${encodeURIComponent(imageId)}`,
  delete: (connectionId, region, imageId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/images/${encodeURIComponent(region)}/${encodeURIComponent(imageId)}`,
};
